<template>
  <el-dialog
    title="物流探查预警"
    :visible.sync="isShow"
    width="710px"
    center
    :before-close="closeDialog"
    :close-on-click-modal='false'
    :close-on-press-escape='false'>
    <div>
      <div v-if="loading" class="logistic-dialog-waiting">
        <div class="logistic-dialog"><img class="sysnc-img" src="@/assets/images/wait.gif"/></div>
        <div class="logistic-dialog">小管家正在努力搬运中，请稍等</div>
      </div>
      <div v-else>
        <div style="margin-bottom: 20px;">
          <el-alert show-icon :closable="false" effect="light">
            <span>根据订单地址和物流公司，判断快递履约过程中经过的中转分拨和末端派件网点是否存在异常，结果仅供参考。</span>
          </el-alert>
        </div>
        <el-table :data="tbody" empty-text="系统经计算，当前所选订单均可正常送达。" max-height="400">
          <el-table-column property="orderId" label="订单编号" width="160"></el-table-column>
          <el-table-column property="undeliverableReason" label="不可达原因" width="240"></el-table-column>
          <el-table-column property="recommendedExpress">
            <template slot="header">
              <span>推荐物流</span>
              <el-tooltip class="item" effect="light" content="根据订单所在线路物流公司的揽签时长进行推荐" placement="right-end">
                <i class="el-icon-info y-fc-4C84FF y-ml-10 y-c-p"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="y-t-ac y-mt-20"
          @size-change="limitChange"
          @current-change="pageChange"
          :current-page.sync="pageNo"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" v-if="tbody.length">关 闭</el-button>
      <el-button type="primary" @click="closeDialog" v-else-if="!loading">关 闭</el-button>
      <el-button type="primary" @click="copyOrderIdsFn" v-if="!loading && tbody.length">复制订单号</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { copyText } from '@/utils/util';
import { getLogisticsWarningApi } from '@/api/waybillPrint/lubanPrint';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    curSelectInfo: {
      type: Object
    }
  },
  data() {
    return {
      isShow: this.value,
      loading: false,
      limit: 100,
      pageNo: 1,
      total: 0,
      gridData: [],
      tbody: []
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    getTableList() {
      let params = {
        pageNo: this.pageNo,
        limit: this.limit,
        userId: this.userMess.loginId,
        ...this.curSelectInfo
      };
      this.loading = true;
      getLogisticsWarningApi(params).then(res=>{
        this.loading = false;
        if (res.message == 'ok') {
          this.gridData = res.data || [];
          this.total = res.data.length;
          this.splitPage();
        } else {
          this.gridData = [];
          this.total = 0;
        }
      }).catch(()=>{
        this.loading = false;
        this.gridData = [];
        this.total = 0;
      });
    },
    closeDialog() {
      this.isShow = false;
      this.$emit('close');
    },
    // 每页条数改变
    limitChange(limit) {
      this.limit = limit;
      this.pageNo = 1;
      this.splitPage();
    },
    // 页码改变
    pageChange(page) {
      this.pageNo = page;
      this.splitPage();
    },
    // 分页，每页要展示的数据
    splitPage() {
      let pageNo = this.pageNo;
      let pageLimit = this.limit;
      this.tbody = this.gridData.slice((pageNo - 1) * pageLimit, pageNo * pageLimit);
    },
    copyOrderIdsFn() {
      let orderIds = this.tbody.map(o => { return o.orderId; });
      copyText(orderIds.join('\n'), '订单号已复制成功');
      this.closeDialog();
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.logistic-dialog-waiting {
  .logistic-dialog {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    margin-bottom: 18px;
    .sysnc-img {
      display: inline-block;
      width: 300px;
      height: auto;
    }
  }
}
</style>
